module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "a-form-inputs"
  }, [_c('form', {
    staticClass: "m-form",
    attrs: {
      "name": "pastLossOfEarnings"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n            Pre-accident Earnings\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                    Is there any past loss of earnings?\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "past_loss_of_earnings",
      "table-control": true
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pastLossOfEarnings),
      expression: "pastLossOfEarnings"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "id": "past_loss_of_earnings",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.pastLossOfEarnings = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("No")])])])], 1), _vm._v(" "), (_vm.pastLossOfEarnings) ? _c('div', {
    staticClass: "flex-grid__item flex-grid--space-left"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                    Calculate past losses or enter your own\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "past_loss_of_earnings",
      "table-control": true
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ownPastLosses),
      expression: "ownPastLosses"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "id": "own_past_losses",
      "name": "own_past_losses",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.ownPastLosses = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("Calculate for me")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Enter your own figure")])])])], 1) : _vm._e()]), _vm._v(" "), (_vm.pastLossOfEarnings && !_vm.ownPastLosses) ? _c('div', [_c('div', {
    staticClass: "flex-grid a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item"
  }, [_c('div', {
    staticClass: "u-d-flex"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                            Employment Income\n                        ")]), _vm._v(" "), _c('icon-tooltip', {
    attrs: {
      "tooltip-name": "pre-accident-income",
      "tooltip-text": "This is the claimant's income at the date of the accident.",
      "side": "right",
      "text-width": "200",
      "icon-type": "info",
      "icon-colour": "m-icon--dark"
    }
  })], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "employment_income",
      "table-control": true,
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "model",
      rawName: "v-model.number",
      value: (_vm.employmentIncome),
      expression: "employmentIncome",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "name": "employment_income",
      "id": "employment_income",
      "type": "number",
      "required": ""
    },
    domProps: {
      "value": (_vm.employmentIncome)
    },
    on: {
      "focus": function($event) {
        _vm.employmentIncome = _vm.employmentIncome || ''
      },
      "blur": [function($event) {
        _vm.employmentIncome = _vm.employmentIncome || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.employmentIncome = _vm._n($event.target.value)
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('employment_income')
    }
  }, [_vm._v("\n                            This is the claimant's income at the date of the accident is required\n                        ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item flex-grid--space-left"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                        Net/Gross\n                    ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "employment_net_gross",
      "table-control": true
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.employmentNetGross),
      expression: "employmentNetGross"
    }],
    attrs: {
      "disabled": _vm.disableNetGross
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.employmentNetGross = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "net"
    }
  }, [_vm._v("Net")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "gross"
    }
  }, [_vm._v("Gross")])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                        Total Net Income\n                    ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "total_net_income",
      "table-control": true,
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.totalNetIncome),
      expression: "totalNetIncome"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "number",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.totalNetIncome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.totalNetIncome = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item flex-grid--space-left"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                        Employment Type\n                    ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "employment_type",
      "table-control": true
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.employmentType),
      expression: "employmentType"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.employmentType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "employed"
    }
  }, [_vm._v("Employed")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "self_employed"
    }
  }, [_vm._v("Self-employed")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "part_employed"
    }
  }, [_vm._v("Part-employed")])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item flex-grid--space-left"
  }, [_c('div', {
    staticClass: "u-d-flex"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                        Update Total Net Income\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "p-pi-income__ashe-average-tooltip"
  }, [_c('modal-in-the-wild', {
    attrs: {
      "modal-name": "pre-accident-income_ashe-average"
    }
  }, [_c('div', {
    staticClass: "p-pi-income__ashe-average-tooltip"
  }, [_c('icon-tooltip', {
    attrs: {
      "tooltip-text": "Click to view information",
      "side": "right",
      "text-width": "140",
      "icon-type": "info",
      "icon-colour": "m-icon--dark"
    }
  })], 1)])], 1)]), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--small ashe p-pi-income__ashe-average-button",
    on: {
      "click": function($event) {
        return _vm.selectSalary(null)
      }
    }
  }, [_vm._v("\n                    Use ASHE average\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--small u-no-margin refine",
    on: {
      "click": _vm.openDialog
    }
  }, [_vm._v("\n                    Refine by occupation\n                ")])])]) : _vm._e(), _vm._v(" "), (_vm.pastLossOfEarnings && _vm.ownPastLosses) ? _c('div', [_c('div', {
    staticClass: "flex-grid a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item"
  }, [_c('control', {
    attrs: {
      "for": "employment_income",
      "table-control": true,
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "model",
      rawName: "v-model.number",
      value: (_vm.pastLossOfEarningsNetTotal),
      expression: "pastLossOfEarningsNetTotal",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "name": "past_loss_net",
      "id": "past_loss_net",
      "type": "number",
      "required": ""
    },
    domProps: {
      "value": (_vm.pastLossOfEarningsNetTotal)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pastLossOfEarningsNetTotal = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('pastLossOfEarningsNetTotal')
    }
  }, [_vm._v("\n                            You must enter a value for past losses.\n                        ")])], 1)], 1)])]) : _vm._e()]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "pre-accident-income_ashe-average",
      "no-default-button": "true"
    }
  }, [_c('h2', [_vm._v("ASHE Average")]), _vm._v("\n        We have provided average gross (median) earnings by selected gender & occupational categories according\n        to the Average Survey of Hours and Earnings (ASHE). The data are collected and published by the Office of\n        National Statics (ONS) annually and can be found here.\n    ")]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": 'ons_salary_' + this.uniqueId,
      "no-default-button": "true"
    }
  }, [_c('div', {
    staticClass: "p-day-one__refine-occupation"
  }, [_c('h2', [_vm._v("Refine by occupation")]), _vm._v(" "), (_vm.selectedNode) ? _c('div', [_c('p', [_vm._v("\n                    Your current selection - "), _c('strong', [_vm._v(_vm._s(_vm.getLastNode().description))]), _c('br'), _vm._v(" "), (_vm.getLastNode().code.length !== 3) ? _c('span', [_vm._v("Select a salary, expand down further or use the average salary for this whole group")]) : _c('span', [_vm._v("Select a salary or use the average salary for this whole group")])]), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--small",
    on: {
      "click": function($event) {
        return _vm.unselectNode(_vm.selectedNode)
      }
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--small",
    on: {
      "click": function($event) {
        return _vm.selectSalary(_vm.selectedNode)
      }
    }
  }, [_vm._v("Use average\n                    " + _vm._s(_vm.displaySalary(_vm.selectedNode)) + "\n                ")])]) : _c('div', [_c('p', [_vm._v("\n                    Select a salary or expand the group\n                ")])]), _vm._v(" "), _c('div', [_c('div', [_c('table', {
    staticClass: "a-table__small a-table a-table--full-width"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Code")]), _vm._v(" "), _c('th', [_vm._v("Description")]), _vm._v(" "), _c('th', [_vm._v("Salary")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30"
    }
  }), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30"
    }
  })])]), _vm._v(" "), (_vm.loading) ? _c('tbody', [_c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "5"
    }
  }, [_c('div', {
    staticClass: "a-loader--table"
  })])]) : _c('tbody', _vm._l((_vm.nodes), function(node) {
    return _c('tr', {
      staticClass: "selected--row"
    }, [_c('td', [_vm._v(_vm._s(node.code))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(node.description))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.displaySalary(node)))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "a-button a-button--small",
      attrs: {
        "disabled": node.code.length === 4
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.selectNode(node)
        }
      }
    }, [_vm._v("\n                                    Expand\n                                ")])]), _vm._v(" "), _c('td', [(node.salary !== 'x') ? _c('button', {
      staticClass: "a-button a-button--small",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.selectSalary(node, _vm.type)
        }
      }
    }, [_vm._v("\n                                    Select\n                                ")]) : _vm._e()])])
  }), 0)])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d7b30a92!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/personal-injury-claims/steps/past-loss-of-earnings/PreAccidentEarnings.vue
// module id = 1816
// module chunks = 0